import {
  IsDate,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  ValidateIf,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { IAdapterAssignmentChangeAction } from "./adapter-assignment-change-action.interface";
import { QueryDto } from "../query";

export class AdapterAssignmentChangeActionDto
  implements IAdapterAssignmentChangeAction
{
  @IsNotEmpty()
  folder_id: string;

  @IsDate()
  start_date: Date;

  @IsOptional()
  @IsNumber()
  hours?: number;

  @IsNotEmpty()
  @ValidateIf((obj, value) => value !== null)
  availability_header_id: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;

  @IsOptional()
  auto_post?: boolean;
}
